var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.419)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.537 6.686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.983,13.922V7.572h2.131l.32-2.475h-2.45V3.516c0-.716.2-1.2,1.227-1.2h1.31V.1A17.759,17.759,0,0,0,42.61,0a2.982,2.982,0,0,0-3.183,3.271V5.1H37.29V7.572h2.137v6.35Z",
    transform: "translate(-37.29)",
    fill: "inherit"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.419)",
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0l8,14L24,28H8L0,14,8,0Z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.580320358276367 0.9999980926513672 L 1.151748657226562 13.99999904632568 L 8.580320358276367 27 L 23.41967964172363 27 L 30.84825134277344 13.99999904632568 L 23.41967964172363 0.9999980926513672 L 8.580320358276367 0.9999980926513672 M 8 -1.9073486328125e-06 L 24 -1.9073486328125e-06 L 32 13.99999904632568 L 24 28 L 8 28 L 0 13.99999904632568 L 8 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "inherit"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/share_facebook.58c5f407155acb517b08983cfd962777.svg";
export { ForwardRef as ReactComponent };